import i from './tariff-simulation.container';

export default i;
